export function getWaitingSongCount(queueLength) {
  return Math.max(0, Number(queueLength || 0) - 1)
}

export function deriveHostIsPlaying({ playbackAvailable, queueLength, roomIsPaused }) {
  return Boolean(playbackAvailable && queueLength > 0 && roomIsPaused === false)
}

export function getPlaybackAction(isPlaying) {
  return isPlaying
    ? { event: 'pause', label: 'Pause', icon: '⏸' }
    : { event: 'play', label: 'Play', icon: '▶️' }
}
